var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"to":_vm.to,"variant":"primary"}},[_c('feather-icon',{attrs:{"icon":"PlusIcon"}}),_vm._v(" Tambah ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }